import React from 'react';

import { getWebApp } from '@tg-web/utils';

// Inside Telegram (initData is set) its button covers the UI and cannot be
// closed on a phone; a normal browser keeps it.
export const TanStackRouterDevtoolsOnlyDev =
  process.env.NODE_ENV === 'production' || getWebApp().initData
    ? () => null // Render nothing in production or inside Telegram
    : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );
